import React from 'react';
import PropTypes from 'prop-types';

const ProductImage = ({ product, imgFormat, imgSize, imgClass }) => {
  let imgSrc = 'https://dummyimage.com/250x250/888/fff.png';

  if (product.dlgImages) {
    product.dlgImages.map(item => {
      if (item.format === imgFormat) {
        imgSrc = item[imgSize].url;
      }
      return null;
    });
  } else if (product.dlgImage) {
    imgSrc = product.dlgImage[imgSize].url;
  }

  return <img className={imgClass} src={imgSrc} alt={product.name} />;
};

ProductImage.propTypes = {
  product: PropTypes.shape().isRequired,
  imgFormat: PropTypes.string,
  imgSize: PropTypes.string,
  imgClass: PropTypes.string,
};

ProductImage.defaultProps = {
  imgFormat: 'thumbnail',
  imgSize: 's',
  imgClass: '',
};

export default ProductImage;
